import { render, staticRenderFns } from "./violationRecord.vue?vue&type=template&id=c8f2083c&scoped=true&"
import script from "./violationRecord.vue?vue&type=script&lang=js&"
export * from "./violationRecord.vue?vue&type=script&lang=js&"
import style0 from "./violationRecord.vue?vue&type=style&index=0&id=c8f2083c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8f2083c",
  null
  
)

export default component.exports